<template>
  <div class="com-coupon">
    <div class="coupon-items clearfix">
      <div
        :class="{'coupon-item':true,'pointer':canClick&&v.is_useable==true}"
        v-for="(v,i) in list"
        :key="i"
        @click="chooseCoupon(v,i)"
      >
        <div class="c-i-top" :class="{'gray':v.use_status!=1||v.is_useable==false}">
          <p class="coupon-name">{{v.coupon_name}}</p>
          <p class="name">
            满
            <span class="use-condition">{{v.use_condition}}</span>
            元减
            <span class="coupon-amount">{{v.coupon_amount}}</span>
            元
          </p>
          <p class="time">{{(v.start||v.start_time)+' - '+(v.end||v.end_time)}}</p>
        </div>
        <div class="c-i-bot">
          <span class="txt">限平台：</span>
          <span class="cont">{{v.use_scope|useScope}}</span>
        </div>
        <!-- <div v-if="canClick&&activeIndex==i" class="icon-use">使用中</div> -->
        <i v-if="canClick&&activeIndex==i" class="el-icon-circle-check icon-check"></i>
        <img v-if="v.use_status==2" class="icon-tag" src="/static/img/using.png">
        <img v-if="v.use_status==3" class="icon-tag" src="/static/img/expired.png">
      </div>
    </div>
    <div class="no-data" v-if="list.length==0">没有{{canClick?"可用":"相关"}}优惠券...</div>
  </div>
</template>
<script>
export default {
  name: "userCoupon",
  props: {
    list: {
      type: Array,
      default: []
    },
    canClick: {
      type: Boolean,
      default: false
    },
    activeIndex: {
      type: Number,
      default: -1
    },
    id: {
      type: String,
      default: ""
    }
  },
  methods: {
    chooseCoupon(v, i) {
      if (!this.canClick||!v.is_useable) return;
      this.$emit("transferCouponId", this.id != v.id ? v.id : "");
      this.$emit("transferCouponIndex", this.id != v.id ? i : "");
    }
  },
  filters: {
    useScope(status) {
      const obj = {
        1: "全平台通用"
      };
      return obj[status];
    }
  }
};
</script>
<style lang="scss" scoped>
.coupon-items {
  .coupon-item {
    float: left;
    width: 288px;
    margin: 0 15px 15px 0;
    border-radius: 5px;
    overflow: hidden;
    // cursor: pointer;
    position: relative;
    .c-i-top {
      padding: 10px 10px 20px;
      background: url("/static/img/coupon.png");
      background-size: 100% 100%;
      color: #fff;
      height: 120px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .coupon-name {
        text-align: center;
        font-size: 20px;
        font-weight: bold;
      }
      .name {
        text-align: center;
        .coupon-amount {
          font-size: 22px;
        }
      }
      .time {
        text-align: center;
      }
      &.gray {
        background: url("/static/img/coupon_gray.png");
        background-size: 100% 100%;
      }
    }
    .c-i-bot {
      border: 1px solid #e6e6e6;
      border-top: 0;
      padding: 5px 10px;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      .cont {
        color: #999;
      }
    }
    .icon-use {
      position: absolute;
      right: -21px;
      top: 10px;
      background: linear-gradient(to right, #ffd778, #fd314a);
      color: #fff;
      width: 80px;
      transform: rotate(45deg);
      text-align: center;
      line-height: 20px;
    }
    .icon-check {
      position: absolute;
      right: 10px;
      top: 10px;
      color: #ff6b56;
      font-size: 25px;
      font-weight: bold;
    }
    .icon-tag {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 60px;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}
</style>
<style>
.coupon-tabs .el-tabs__content {
  padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/userCoupon.vue